import { List } from 'immutable';
import { createSelector } from 'reselect';

export const smartlinkUnitSelector = state => state.entities.smartlinkUnits;

export function filterSmartlinksBySites(smartlinks, sites) {
  return createSelector(smartlinks, sites, (smartlinks, sites) =>
    smartlinks.filter(smartlink => sites.has(smartlink.get('site', 0))),
  );
}

export function addRadiosToSmartlink(a, b) {
  return createSelector(a, b, (smartlinks, radios) =>
    smartlinks.map(smartlink => {
      if (smartlink.get('radio') !== null) {
        return smartlink.set('radio', radios.get(smartlink.get('radio', 0).toString(), null));
      }
      return smartlink;
    }),
  );
}

export function addModelToSmartlink(a, b) {
  return createSelector(a, b, (smartlinks, models) =>
    smartlinks.map(smartlink => {
      if (smartlink.get('model') !== null) {
        return smartlink.set('model', models.get(smartlink.get('model', 0).toString(), null));
      }
      return smartlink;
    }),
  );
}

export function addRelaysToSmartlink(a, b) {
  return createSelector(a, b, (smartlinks, relays) => {
    if (smartlinks.isEmpty()) {
      return smartlinks;
    } // breakout if no data for smartlinks
    smartlinks = smartlinks.map(unit => unit.set('relays', List()));
    relays.forEach(relay => {
      const id = relay.get('relay_controller', '-1').toString(); // id of smartlink unit
      const tmp = smartlinks.get(id, '-1'); // get that unit
      if (tmp === '-1') {
        return;
      } // breakout if unit doesn't exist with given id
      const newList = tmp.get('relays').push(relay); // create new list
      smartlinks = smartlinks.set(id, tmp.set('relays', newList)); // add the new entry
    });
    return smartlinks;
  });
}

export function addIntrusionSensorToSmartlink(a, b) {
  return createSelector(a, b, (smartlinks, sensors) =>
    smartlinks.map(smartlink => {
      if (smartlink.get('intrusion_sensor_configuration', null) != null) {
        return smartlink.set(
          'intrusion_sensor_configuration',
          sensors.get(smartlink.get('intrusion_sensor_configuration', 0).toString(), null),
        );
      }
      return smartlink;
    }),
  );
}

export function addFirmwareVersionToSmartlink(a, b) {
  return createSelector(a, b, (smartlinks, firmwareVersions) =>
    smartlinks.map(smartlink => {
      if (smartlink.get('firmware_version', null) != null) {
        return smartlink.set(
          'firmware_version',
          firmwareVersions.get(smartlink.get('firmware_version', 0).toString(), null),
        );
      }
      return smartlink;
    }),
  );
}

export function addCICToSmartlink(a, b) {
  return createSelector(a, b, (smartlinks, cics) =>
    smartlinks.map(smartlink => {
      if (smartlink.get('cic', null) != null) {
        return smartlink.set('cic', cics.get(smartlink.get('cic', 0).toString(), null));
      }
      return smartlink;
    }),
  );
}
